export class PuestoColaborador {
    puestoid: number = 0;
    nombre: string = "";
    departamentoid: number = 0;
    puestosuperiorid: number = 0;
    activo: boolean = true;
    tipodepartamentoid: number = 0;
    departamentosuperiorid: number = 0;
    nivel: boolean = false;
    nivelid: number = 0;
    areaacademica: boolean = false;
    areaacademicaid: number = 0;
    colaborador: string = "";
    colaboradorid: number = 0;
    puesto:string = "";
    otropuesto: boolean = false;
    gradosid: any;
    constructor(init?: Partial<PuestoColaborador>) {
        Object.assign(this, init);
    }
}
